export const GET_IDENTITY_VERIFICATION_REQUESTS = 'GET_IDENTITY_VERIFICATION_REQUESTS';
export const GET_IDENTITY_VERIFICATION_REQUEST = 'GET_IDENTITY_VERIFICATION_REQUEST';
